import { render, staticRenderFns } from "./add-sites.vue?vue&type=template&id=4cfba7b6&scoped=true"
import script from "./add-sites.vue?vue&type=script&lang=js"
export * from "./add-sites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfba7b6",
  null
  
)

export default component.exports